import {inject} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {CustomToastService} from '../../@core/utils/custom-toast.service';

/**
 * Abstrakte Basisklasse für formularbasierte Modal-Komponenten.
 * Stellt gemeinsame Logik für save() und cancel() bereit.
 */
export abstract class AbstractFormModalComponent {
  protected readonly activeModal = inject(NgbActiveModal);
  protected readonly customToastService = inject(CustomToastService);
  protected readonly translateService = inject(TranslateService);

  /** Das reaktive Formular der Subklasse */
  protected abstract form: AbstractControl;

  /** i18n-Schlüssel für die Validierungsfehlermeldung */
  protected abstract validationErrorKey: string;

  /** Gibt den Wert zurück, mit dem das Modal geschlossen wird */
  protected abstract getCloseValue(): unknown;

  cancel(): void {
    this.activeModal.dismiss();
  }

  save(): void {
    if (this.form.valid) {
      this.activeModal.close(this.getCloseValue());
    } else {
      this.form.markAllAsTouched();
      this.customToastService.showError(
        this.translateService.instant(this.validationErrorKey)
      );
    }
  }
}

